import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function Ct2dModelTrainingPage() {
  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4>Please fill up the 2D Model Training form</h4>
      <DynamicForm page={'ct2dTraining'} />
    </Paper>
  )
}

export default Ct2dModelTrainingPage
